import {GET_CANDIDATE_INTERVIEW_LIST_DETAILS ,GET_CANDIDATE_INTERVIEW_LIST_DETAILS_SUCCESS,GET_CANDIDATE_INTERVIEW_LIST_DETAILS_FAIL} from './actionTypes'


const initialState = {
    loader: false,
    candidateInterviewList: null,
    error: null,
    CandidateInterviewUrl: null
}

const CandidateInterviewReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CANDIDATE_INTERVIEW_LIST_DETAILS:
            state = {
                ...state,
                loader: true,
                candidateInterviewList: null,
                
            }
            break
        case GET_CANDIDATE_INTERVIEW_LIST_DETAILS_SUCCESS:
            state = {
                ...state,
                loader: false,
                candidateInterviewList: action.payload,
                error: null
            }
            break
        case GET_CANDIDATE_INTERVIEW_LIST_DETAILS_FAIL:
            state = {
                ...state,
                loader: false,
                candidateInterviewList: null,
                error: action.payload
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}
export default CandidateInterviewReducer